/**
 * A2UI v0.8 server→client 信封常見順序：`beginRendering` 應在任何 `surfaceUpdate` 之前。
 * 若順序相反，部分 runtime（@a2ui/web_core）在未建立 surface/root 前就組樹，會誤判循環並拋錯。
 *
 * 同類型信封之間保留原本相對順序（穩定排序）。
 *
 * @param {unknown[]} messages
 * @returns {unknown[]}
 */
export function normalizeA2uiV08Messages(messages) {
  if (!Array.isArray(messages) || messages.length === 0) return messages;

  const orderRank = {
    beginRendering: 0,
    dataModelUpdate: 1,
    surfaceUpdate: 2,
    deleteSurface: 3,
  };

  return messages
    .map((msg, idx) => ({ msg, idx }))
    .sort((a, b) => {
      const keyA = a.msg && typeof a.msg === 'object' ? Object.keys(a.msg)[0] : '';
      const keyB = b.msg && typeof b.msg === 'object' ? Object.keys(b.msg)[0] : '';
      const rankA = keyA in orderRank ? orderRank[keyA] : 50;
      const rankB = keyB in orderRank ? orderRank[keyB] : 50;
      if (rankA !== rankB) return rankA - rankB;
      return a.idx - b.idx;
    })
    .map(({ msg }) => msg);
}
